import _ from "lodash";
import constants from "./seo-constants";
import { OpenGraphMedia } from "next-seo/lib/types";

export const getSEOTitle = (
  sportKey: string | undefined,
  pageKey: string | undefined,
  filterKey: string | null,
  conferenceKey: string | null,
  defaultTitle: string | undefined
) => {
  let data: string | undefined = "";
  if (sportKey) {
    data += `${sportKey}.`;
    if (pageKey) {
      data += `${pageKey}.`;
      if (filterKey) {
        data += `${filterKey}.`;
        if (conferenceKey) {
          data += `${conferenceKey}.`;
        }
      } else if (conferenceKey) {
        data += `spread.${conferenceKey}.`;
      }
    }
  }
  data = _.get(constants, `${data}seoTitle`, undefined);
  if (!data) {
    data = defaultTitle;
  }
  return data;
};

export const getSEODescription = (
  sportKey: string | undefined,
  pageKey: string | undefined,
  filterKey: string | null,
  conferenceKey: string | null
) => {
  let data: string | undefined = "";
  if (sportKey) {
    data += `${sportKey}.`;
    if (pageKey) {
      data += `${pageKey}.`;
      if (filterKey) {
        data += `${filterKey}.`;
        if (conferenceKey) {
          data += `${conferenceKey}.`;
        }
      } else if (conferenceKey) {
        data += `spread.${conferenceKey}.`;
      }
    }
  }
  data = _.get(constants, `${data}description`, undefined);
  if (!data) {
    data = undefined;
  }
  return data;
};

export const getSEOH1 = (
  sportKey: string,
  pageKey: string,
  filterKey: string | null,
  conferenceKey: string | null,
  defaultTitle: string
) => {
  let data: string | undefined = "";
  if (conferenceKey) {
    data = _.get(constants, `${sportKey}.${pageKey}.${filterKey}.${conferenceKey}.h1`, undefined);
  } else if (filterKey) {
    data = _.get(constants, `${sportKey}.${pageKey}.${filterKey}.h1`, undefined);
  } else {
    data = _.get(constants, `${sportKey}.${pageKey}.h1`, undefined);
  }
  if (!data) {
    data = defaultTitle;
  }
  return data;
};

export const getSEOImage = (
  sportKey: string,
  pageKey: string,
  filterKey: string | null,
  conferenceKey: string | null
): OpenGraphMedia => {
  let data: string = "";
  if (sportKey) {
    data += `${sportKey}.`;
    if (pageKey) {
      data += `${pageKey}.`;
      if (filterKey) {
        data += `${filterKey}.`;
        if (conferenceKey) {
          data += `${conferenceKey}.`;
        }
      } else if (conferenceKey) {
        data += `spread.${conferenceKey}.`;
      }
    }
  }

  let image: OpenGraphMedia | null = _.get(constants, `${data}image`, null);
  if (!image) {
    image = { url: "/og-image.png", alt: "BetQL" };
  }
  return image;
};
